import Axios, { AxiosError, AxiosHeaders } from 'axios' 
import { enqueueSnackbar } from 'notistack';

export const MILESPAY_TOKEN_NAME = '@milespay/token'

export const MILESPAY_API = Axios.create({
    baseURL: `${process.env.REACT_APP_API_URL}`
})
console.log('process.env.REACT_APP_API_URL', process.env.REACT_APP_API_URL)
MILESPAY_API.interceptors.request.use((config) => {
    const token = window.localStorage.getItem(MILESPAY_TOKEN_NAME)

    if (token) {
        (config.headers as AxiosHeaders).set('Authorization', `Bearer ${token}`)
    }

    return config 
})

MILESPAY_API.interceptors.response.use(success => success, (error: AxiosError<{ message?: string }>) => {
    if ([403, 409].includes(error.response?.status as number)) {
        enqueueSnackbar(error.response?.data.message || 'Erro interno! Entre em contato com o administrador do sistema', {
            variant: 'error'
        })
        
        return Promise.resolve(error)
    }

    if (error.response?.status === 401) {
        window?.localStorage?.removeItem(MILESPAY_TOKEN_NAME)
        
        if (window.location.pathname !== '/login' && !window.location.pathname.includes('/checkout/cielo')) {
            window.location.href = '/login'
        }
    }

    return Promise.reject(error)
})